export default {
    auxRegistrationApiBase: "/api",
    auxTabsEnabled: true,
    auxApiBase: '/api/v1',
    auxCoins: ['WEC'],
    // Match unlockerAux.rpc[].depth for each coin.
    auxBlockConfirmations: { WEC: 101 },
    auxExplorers: {
        WEC: {
            url: 'https://wcashexplorer.com/',
            height: 'https://wcashexplorer.com/block/',
            hash: 'https://wcashexplorer.com/block/',
            tx: 'https://wcashexplorer.com/tx/',
        },
    },
    name: "Zcash",
    coin: "ZEC",
    scheme: "SOLO",
    account: 't1MqmXugaf5VSQvAVBhshK28S2kW762kNNH',
    explorer_url: 'https://zcashinfo.com/',
    coingecko: 'https://www.coingecko.com/en/coins/zcash',
    explorer: {
        address: "https://zcashinfo.com/address/",
        height: "https://zcashinfo.com/block/",
        hash: "https://zcashinfo.com/block/",
        tx: "https://zcashinfo.com/tx/",
    },
    extraNonce: {
        default: 4,
        profiles: [
            { size: 4, suffix: "", standard: true, recommended: true },
            { size: 5, suffix: "-en5" },
            { size: 6, suffix: "-en6" },
            { size: 7, suffix: "-en7" },
            { size: 8, suffix: "-en8" },
        ],
    },
    ports: [
        {
            info: "LOW",
            host: "molepool.com",
            port: 1101,
            diff: 256,
            customDifficulty: false,
        },
        {
            info: "MID",
            host: "molepool.com",
            port: 1102,
            diff: 1024,
            customDifficulty: true,
        }
    ]
};
